import { defineStore } from 'pinia'

export const useConfirmModalStore = defineStore('comfirmModal', {
  state: () => {
    return {
      modalText: '',
      toggleConfirmModal: false,
    }
  }
  ,

  actions: {
    setText(text) {
      this.modalText = text;
    },
    openModal() {
      this.toggleConfirmModal = true;
      this.createDim();
    },
    closeModal() {
      this.toggleConfirmModal = false;
      this.createDim();
    },
    createDim() {
      const self = this;
      if (self.toggleConfirmModal) {
        const dimDiv = window.document.createElement('div')
        dimDiv.setAttribute('class', 'dim active')
        window.document.body.appendChild(dimDiv)
      } else {
        window.document.querySelector('.dim.active').remove();
      }
    },
  }
})